<template>
  <div class="header">
    <div class="header-inner">
      <div class="header-logo">{{title}}</div>

      <div class="header-menu">
        <div class="header-menu-item">
          <i class="fa fa-mobile"></i>&nbsp;手机扫码玩
          <div class="header-menu-item__qrcode">
            <vue-qr :text="url" :size="200"></vue-qr>
          </div>
        </div>
        <div class="header-menu-item">
          <a href="//www.bqrdh.com" target="_blank"><i class="fa fa-home"></i>主站</a>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import {i18n, lan} from '../../unit/const'
  import VueQr from 'vue-qr'

  export default {
    name: "Header",
    components: {
      VueQr
    },
    mounted() {
      console.log(window.location.href)
    },
    data() {
      return {
        url: window.location.href
      }
    },
    computed: {
      title: () => i18n.title[lan]
    }
  }
</script>

<style scoped lang="less">
  .header {
    height: 50px;
    line-height: 50px;
    background-color: #f8f8f8;
    border-bottom: 1px solid #e7e7e7;

    &-inner {
      max-width: 960px;
      margin: 0 auto;
    }

    &-logo {
      margin-left: 20px;
      float: left;
      color: #777;
    }

    &-menu {
      float: right;
      display: flex;
      margin-right: 20px;

      a {
        color: #777;
        text-decoration: unset;
      }

      &-item  {
        position: relative;
        padding: 0 5px;
        font-size: .9rem;
        color: #777;
        cursor: pointer;

        &:hover {
           opacity: .6;

          .header-menu-item__qrcode {
            opacity: 1;
          }
        }

        &__qrcode {
          opacity: 0;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          transition: .5s;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// index.vue?a9e95f1a